<template>
    <v-layout align-top justify-center row wrap>
        <v-flex xs12 sm12 md12 lg9 xl8 class="pa-2">
            <template v-if="!silentLoading || silentLoading && silentLoadingSection == 'consents'">
                <h2>PRIVOLITEV ZA OBDELAVO OSEBNIH PODATKOV</h2>
                <empty-space/>
                <p>
                    Upravljavec osebnih podatkov Engrotuš d.o.o., Cesta v Trnovlje 10a, 3000 Celje Dovoljujem, da podjetje
                    Engrotuš, d.o.o. obdeluje moje podatke, za spodaj opredeljene namene (prosimo označite, ali se strinjate
                    z obdelovanjem vaših osebnih podatkov za zapisan namen ter potrdite s klikom na gumb ‘shrani nastavitve’
                    - tudi, če ne podate nobene privolitve):
                </p>
                <h3>SKUPNA PRIVOLITEV</h3>
                <v-checkbox
                        v-model="confirm_all_consents"
                        color="primary"
                        required
                >
                    <div slot="label">
                        Strinjam se z vsemi spodaj opredeljenimi nameni obdelovanja osebnih podatkov ter kanali obveščanja.
                    </div>
                </v-checkbox>
                <split-content/>
                <empty-space/>
                <h3>POSAMEZNA PRIVOLITEV</h3>
                <span>*(izpolnite le v primeru, če se ne strinjate s skupno privolitvijo)</span>
                <profile-consents :adjusted_offer.sync="adjusted_offer" :market_researches.sync="market_researches"/>
                <split-content/>
                <empty-space/>
                <h3>KANALI ZA OBVEŠČANJE</h3>
                <profile-consents-channels :direct.sync="direct" :email.sync="email" :sms.sync="sms" :digital.sync="digital"
                                           :push.sync="push" :call.sync="call"/>
                <v-snackbar
                        v-model="consents_saved"
                        color="success"
                        top
                >
                    Privolitve so bile uspešno shranjene.
                    <v-btn
                            text
                            @click="consents_saved = false"
                    >
                        Zapri
                    </v-btn>
                </v-snackbar>
                <v-snackbar
                        v-model="consentsSavedError"
                        color="error"
                        top
                >
                    {{ consentsSavedErrorMSG }}
                    <v-btn
                            text
                            @click="consentsSavedError = false"
                    >
                        Zapri
                    </v-btn>
                </v-snackbar>
                <empty-space/>
                <v-btn depressed large block color="primary_action" @click="saveConsents()" :loading="loading">Shrani
                    nastavitve
                </v-btn>
                <empty-space/>
                <split-content/>
                <empty-space/>
                <h2>HVALA, KER NAM ZAUPATE</h2>
                <empty-space/>
                <p>
                    V Engrotušu z največjo odgovornostjo in skladno z vsakokrat veljavnim zakonom o varstvu osebnih podatkov
                    ter določili evropske Uredbe na področju varstva osebnih podatkov (GDPR) skrbimo za vaše podatke. Vaša
                    dovoljenja lahko kadarkoli prekličete skladno s pripadajočimi splošnimi pogoji poslovanja Tuš kluba. Za
                    dodatne informacije smo vam vedno na voljo na brezplačni telefonski številki 080 13 10.
                </p>
                <h2>Obrazložitev namenov obdelovanja osebnih podatkov:</h2>
                <empty-space/>
                <p>Pri obveščanju preko SMS/MMS sporočil se Tuš klub član strinja, da se lahko njegovi osebni podatki, ki
                    jih je vpisal v pristopni obrazec (obvezni in neobvezni podatki)* in podatki pridobljeni preko
                    sodelovanja v nagradnih igrah, s komunikacijo preko e-pošte, komunikacije s Tuševim centrom za pomoč
                    strankam, uporabe spletnih aplikacij uporabljajo za namene SMS in MMS obveščanja o ugodnostih,
                    aktivnostih, storitvah in dogodkih Tuš kluba. Podatki se lahko obdelujejo do preklica privoljenja oz. do
                    prenehanja članstva v Tuš klubu.</p>
                <p>Pri pošiljanju prilagojene ponudbe se posameznik strinja, da se lahko njegovi podatki, ki jih je vpisal v
                    pristopni obrazec (obvezni in neobvezni)*, podatki o posameznih nakupih in podatki pridobljeni preko
                    sodelovanja v nagradnih igrah, s komunikacijo preko e-pošte, komunikacije s Tuševim centrom za pomoč
                    strankam, uporabe spletnih aplikacij obdelujejo za namene priprave prilagojene ponudbe. V okviru
                    priprave prilagojene ponudbe se izvaja profiliranje na podlagi podanih podatkov ter podatkov o obiskanih
                    spletnih straneh organizacije (če se je posameznik ob obisku spletne strani s tem strinjal) ter
                    posredovanje obvestil na kanale, ki jih je posameznik označil. Za namen priprave prilagojene ponudbe se
                    uporabljajo vsi podani podatki, ki se hranijo od pričetka članstva v Tuš klubu do poteka zakonskih
                    rokov, opredeljenih v splošnih pogojih. Podatki se prenehajo obdelovati v primeru preklica privoljenja
                    oz. do prenehanja članstva v Tuš klubu. Prilagojene ponudbe se posredujejo na kanale, ki jih je
                    posameznik označil.</p>
                <p>Pri trženjskih raziskavah se posameznik strinja, da se lahko njegovi osebni podatki iz pristopnega
                    obrazca (obvezni in neobvezni)* in podatki pridobljeni preko sodelovanja v nagradnih igrah, s
                    komunikacijo preko e-pošte, komunikacije s Tuševim centrom za pomoč strankam, uporabe spletnih aplikacij
                    ter podatki o nakupovalnih navadah uporabljajo za izvajanje trženjskih raziskav. Podatki se lahko
                    obdelujejo do preklica privoljenja oz. do prenehanja članstva v Tuš klubu. Ankete se posredujejo na
                    kanale, ki jih je posameznik označil. *V pristopnem obrazcu so vpisani obvezni podatki: ime, priimek,
                    ulica, hišna številka, poštna številka, kraj, država, spol, datum rojstva in neobvezni podatki:
                    elektronski naslov, mobilna številka, stacionarni telefon, izobrazba, število družinskih članov, datum
                    rojstva in spol otrok, status. S potrditvijo ste seznanjeni, da lahko v vsakem trenutku prekličete
                    privolitev za uporabo svojih osebnih podatkov na isti način kot ste privolitev podali (preklic se lahko
                    tudi nanaša samo na neobvezne podatke), da ste seznanjeni s pravico do seznanitve osebnih podatkov,
                    pravico dopolnitve, popravka, omejitve obdelave, izbrisa, prenosljivosti in ugovora ter s pravico
                    vložiti pritožbo pri informacijskem pooblaščencu. Splošni pogoji poslovanja Tuš kluba, ki so v uporabi
                    od 25. 5. 2018 so na voljo na prodajnih mestih Tuš ter na spletni strani www.tus.si.</p>

                <a target="_blank" v-on:click.stop="" href="https://www.tus.si/o-tus-klub-kartici/splosni-pogoji-tus-klub/">Splošni pogoji poslovanja Tuš kluba, ki so v uporabi od 25. 5. 2018</a>
            </template>
            <template v-if="silentLoading  && silentLoadingSection!='consents'">
                <div class="loader">
                    <empty-space />
                    <v-progress-circular :indeterminate="true" size="50" ></v-progress-circular>
                </div>
            </template>
        </v-flex>
    </v-layout>
</template>

<script>
    import ProfileConsents from "../ProfileConsents";
    import ProfileConsentsChannels from "../ProfileConsentsChannels";
    import SplitContent from "../SplitContent";
    import EmptySpace from "../EmptySpace";
    import utils from "../../store/utils";
    import {userService} from "../../services";

    export default {
        name: "ConsentsTab",
        components: {SplitContent, ProfileConsents, ProfileConsentsChannels, EmptySpace},
        data: vm => ({
            loading: false,
            consents_saved: false,
            consentsSavedError: false,
            consentsSavedErrorMSG: '',
        }),
        computed: {
            silentLoading: utils.vuexBuildSetGet(this, 'profile', 'silentLoading'),
            silentLoadingSection: utils.vuexBuildSetGet(this, 'profile', 'silentLoadingSection'),
            adjusted_offer: utils.vuexBuildSetGet(this, 'profile', 'user.consents.adjusted_offer'),
            market_researches: utils.vuexBuildSetGet(this, 'profile', 'user.consents.market_researches'),
            direct: utils.vuexBuildSetGet(this, 'profile', 'user.consent_channels.direct'),
            email: utils.vuexBuildSetGet(this, 'profile', 'user.consent_channels.email'),
            sms: utils.vuexBuildSetGet(this, 'profile', 'user.consent_channels.sms'),
            call: utils.vuexBuildSetGet(this, 'profile', 'user.consent_channels.call'),
            digital: utils.vuexBuildSetGet(this, 'profile', 'user.consent_channels.digital'),
            push: utils.vuexBuildSetGet(this, 'profile', 'user.consent_channels.push'),
            confirm_all_consents: {
                get() {
                    let status = this.adjusted_offer && this.market_researches && this.direct;
                    status = status && this.email && this.sms && this.digital && this.push;
                    status = status && this.call;
                    return status;
                },
                set(value) {
                    this.adjusted_offer = value;
                    this.market_researches = value;
                    this.direct = value;
                    this.email = value;
                    this.sms = value;
                    this.digital = value;
                    this.call = value;
                    this.push = value;
                }
            }
        },
        methods: {
            saveConsents() {
                this.loading = true;
                this.consents_saved = false;
                this.consentsSavedError = false;
                const data = {
                    consents: this.$store.state.profile.user.consents,
                    consent_channels: this.$store.state.profile.user.consent_channels,
                };
                userService.saveConsents(data).then((data) => {
                    this.consents_saved = true;
                    this.$store.dispatch('profile/silentAllAboutMe', {
                        'section': 'consents'
                    });
                }, (error) => {
                    this.consentsSavedError = true;
                    this.consentsSavedErrorMSG = error.message;
                }).finally(() => {
                    this.loading = false;
                });
            }
        }
    }
</script>

<style scoped>

        .loader {
            text-align: center;
        }
</style>